import _classPrivateFieldInitSpec from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classPrivateFieldGet from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet2.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.map.js";
import "core-js/modules/esnext.iterator.reduce.js";
import "core-js/modules/esnext.iterator.some.js";
import Client from "../Client";
import User from "../user/User";
import SalePage from "../salePage/SalePage";
import OrderLine from "../orderLine/OrderLine";
import Invoice from "../invoice/Invoice";
import Payment from "./Payment";
import moment from "moment";
import { date_time_format } from "../../mcn-helpers";
import Offer from "../offer/Offer";
import Product from "../product/Product";
import OrderInvoiceCollection from "./OrderInvoiceCollection";
import OrderCommentCollection from "./OrderCommentCollection";
import OrderLineCollection from "../orderLine/OrderLineCollection";
import JsonMappedModel from "../helpers/JsonMappedModel";
import OrderGoogleSheetSendCollection from "@/assets/js/models/GoogleSheet/OrderGoogleSheetSendCollection";
import SdkAccountOrderCollection from "@/assets/js/models/ECommerceSdk/SdkAccountOrderCollection";
import SdkAccountOrder from "@/assets/js/models/ECommerceSdk/SdkAccountOrder";
import ECommerceSdkAccount from "@/assets/js/models/ECommerceSdk/ECommerceSdkAccount";
var _attributes = /*#__PURE__*/new WeakMap();
export default class Order extends JsonMappedModel {
  constructor(data) {
    super(data);
    _classPrivateFieldInitSpec(this, _attributes, {
      [Order.id_attribute_name]: null,
      [Order.order_id_alias_attribute_name]: null,
      [Order.order_client_attribute_name]: Client,
      [Order.client_attribute_name]: Client,
      [Order.order_call_agent_attribute_name]: User,
      [Order.order_invoices_attribute_name]: OrderInvoiceCollection,
      [Order.order_sale_page_attribute_name]: SalePage,
      [Order.order_with_trashed_sale_page_attribute_name]: SalePage,
      [Order.with_trashed_sale_page_attribute_name]: SalePage,
      [Order.order_status_attribute_name]: null,
      [Order.order_lines_attribute_name]: OrderLineCollection,
      [Order.order_tracking_code_attribute_name]: null,
      [Order.order_tracking_link_attribute_name]: null,
      [Order.created_at_attribute_name]: null,
      [Order.order_call_agent_order_comments_attribute_name]: OrderCommentCollection,
      [Order.order_fulfillment_price_attribute_name]: 0,
      [Order.order_upsell_price_attribute_name]: 0,
      [Order.order_shipping_price_attribute_name]: 0,
      [Order.order_returns_price_attribute_name]: 0,
      [Order.order_tax_percentage_attribute_name]: 0,
      [Order.order_other_percentage_attribute_name]: 0,
      [Order.order_call_agent_shipping_note_attribute_name]: null,
      [Order.order_lines_sum_order_line_total_confirmed_usd_attribute_name]: 0,
      [Order.order_remittance_invoice_attribute_name]: Invoice,
      [Order.total_confirmed_usd_sum_attribute_name]: 0,
      [Order.is_sent_to_warehouse_api_attribute_name]: false,
      [Order.is_sent_to_warehouse_attribute_name]: false,
      [Order.is_sent_to_advertiser_attribute_name]: false,
      [Order.order_payment_type_attribute_name]: null,
      [Order.order_payment_attribute_name]: Payment,
      [Order.order_total_confirmed_usd_attribute_name]: null,
      [Order.order_total_confirmed_attribute_name]: null,
      [Order.payment_status_attribute_name]: null,
      [Order.is_affiliate_paid_attribute_name]: false,
      [Order.is_warehouse_paid_attribute_name]: false,
      [Order.google_sheet_sends_attribute_name]: OrderGoogleSheetSendCollection,
      [Order.sdk_account_orders_attribute_name]: SdkAccountOrderCollection,
      [Order.has_google_sheet_attribute_name]: false,
      [Order.sent_to_all_google_sheets_attribute_name]: false
    });
    _defineProperty(this, "getOrderRemittance", () => {
      return this.getOrderLines().reduce((a, b) => a + (b instanceof OrderLine ? b.getOrderLineUsdConfirmedTotal() : 0), 0);
    });
    _defineProperty(this, "getOrderTotalCommission", () => {
      var _offer$getOfferPayout, _offer$getOfferCommis;
      let offer = this.getWithTrashedOffer();
      let offer_payout = (_offer$getOfferPayout = offer === null || offer === void 0 ? void 0 : offer.getOfferPayout()) !== null && _offer$getOfferPayout !== void 0 ? _offer$getOfferPayout : 0;
      let offer_commission = (_offer$getOfferCommis = offer === null || offer === void 0 ? void 0 : offer.getOfferCommission()) !== null && _offer$getOfferCommis !== void 0 ? _offer$getOfferCommis : 0;
      return offer_payout + offer_commission;
    });
    _defineProperty(this, "getOrderExpenses", () => {
      let has_upsell = false;
      let order_total = this.getOrderLines().reduce((a, b) => {
        if (!(b instanceof OrderLine)) return a;
        if (b.isUpSell()) has_upsell = true;
        return a + b.getUsdTotalConfirmed();
      }, 0);
      return this.getStatus() !== 'returned' ? order_total / 100 * (this.getWarehouseTaxPercentage() + this.getWarehouseOtherPercentage()) + this.getWarehouseFulfillmentPrice() + this.getUpsellPrice() + (has_upsell ? this.getUpsellPrice() : 0) : this.getWarehouseReturnsPrice() + this.getWarehouseShippingPrice();
    });
    this.map(data, _classPrivateFieldGet(_attributes, this));
  }
  static getOrderClientAttributeName() {
    return Order.order_client_attribute_name;
  }
  static getGoogleSheetSendsAttributeName() {
    return Order.google_sheet_sends_attribute_name;
  }
  static getStatusAttributeName() {
    return Order.order_status_attribute_name;
  }
  static getLinesAttributeName() {
    return Order.order_lines_attribute_name;
  }
  static getTrackingCodeAttributeName() {
    return Order.order_tracking_code_attribute_name;
  }
  static getTrackingLinkAttributeName() {
    return Order.order_tracking_link_attribute_name;
  }
  static getShippingNotesAttributeName() {
    return Order.order_shipping_price_attribute_name;
  }
  static getCreatedAtAttributeName() {
    return Order.created_at_attribute_name;
  }
  static getOrderPaymentAttributeName() {
    return Order.order_payment_attribute_name;
  }
  static getOrderWithTrashedSalePageAttributeName() {
    return Order.order_with_trashed_sale_page_attribute_name;
  }
  static getWithTrashedSalePageAttributeName() {
    return Order.with_trashed_sale_page_attribute_name;
  }
  static getOrderIdAliasAttributeName() {
    return this.order_id_alias_attribute_name;
  }
  static getSdkAccountOrdersAttributeName() {
    return this.sdk_account_orders_attribute_name;
  }
  static getHasGoogleSheetAttributeName() {
    return this.has_google_sheet_attribute_name;
  }
  static getSentToAllGoogleSheetsAttributeName() {
    return this.sent_to_all_google_sheets_attribute_name;
  }
  isSentToAllGoogleSheets() {
    return this.getAttribute(Order.getSentToAllGoogleSheetsAttributeName());
  }
  hasGoogleSheet() {
    return this.getAttribute(Order.getHasGoogleSheetAttributeName());
  }
  getGoogleSheetSends() {
    var _this$getAttribute;
    return (_this$getAttribute = this.getAttribute(Order.getGoogleSheetSendsAttributeName())) !== null && _this$getAttribute !== void 0 ? _this$getAttribute : [];
  }
  getOrderAlias() {
    return this.getAttribute(Order.order_id_alias_attribute_name);
  }
  getMomentCreationDate() {
    return moment.utc(this.getCreatedAt()).format(date_time_format);
  }
  getCustomerName() {
    let customer = this.getClient();
    return customer instanceof Client ? customer.getFullName() : null;
  }
  getSeller(trashed = false) {
    let salePage = this.getSalePage(trashed);
    return salePage instanceof SalePage ? salePage.getSeller() : null;
  }
  getSellerName(trashed = false) {
    let seller = this.getSeller(trashed);
    return seller instanceof User ? seller.getUserName() : null;
  }
  getPaymentStatus() {
    return this.getAttribute(Order.payment_status_attribute_name);
  }
  getTotalConfirmedUsd() {
    return this.getAttribute(Order.order_total_confirmed_usd_attribute_name);
  }
  getOrderTotalConfirmedUsd() {
    var _ref, _this$getTotalConfirm;
    return (_ref = (_this$getTotalConfirm = this.getTotalConfirmedUsd()) !== null && _this$getTotalConfirm !== void 0 ? _this$getTotalConfirm : this.getOrderLines().reduce((somme, order_line) => {
      return somme + (order_line instanceof OrderLine ? order_line.getOrderLineUsdConfirmedTotal() : 0);
    }, 0)) !== null && _ref !== void 0 ? _ref : 0;
  }
  getOrderTotalConfirmed() {
    var _ref2, _this$getTotalConfirm2;
    return (_ref2 = (_this$getTotalConfirm2 = this.getTotalConfirmed()) !== null && _this$getTotalConfirm2 !== void 0 ? _this$getTotalConfirm2 : this.getOrderLines().reduce((somme, order_line) => {
      return somme + (order_line instanceof OrderLine ? order_line.getOrderLineConfirmedTotal() : 0);
    }, 0)) !== null && _ref2 !== void 0 ? _ref2 : 0;
  }
  getCreatedAt() {
    return this.getAttribute(Order.created_at_attribute_name);
  }
  getId() {
    return this.getAttribute(Order.id_attribute_name);
  }
  getWithTrashedSalePage() {
    var _this$getAttribute2;
    return (_this$getAttribute2 = this.getAttribute(Order.order_with_trashed_sale_page_attribute_name)) !== null && _this$getAttribute2 !== void 0 ? _this$getAttribute2 : this.getAttribute(Order.order_sale_page_attribute_name);
  }
  getWithTrashedOffer() {
    var _this$getWithTrashedS;
    return (_this$getWithTrashedS = this.getWithTrashedSalePage()) === null || _this$getWithTrashedS === void 0 ? void 0 : _this$getWithTrashedS.getSalePageWithTrashedOffer();
  }
  getWarehouseShippingPrice() {
    return this.getAttribute(Order.order_shipping_price_attribute_name);
  }
  getWarehouseTaxPercentage() {
    return this.getAttribute(Order.order_other_percentage_attribute_name);
  }
  getWarehouseOtherPercentage() {
    return this.getAttribute(Order.order_other_percentage_attribute_name);
  }
  getWarehouseReturnsPrice() {
    return this.getAttribute(Order.order_returns_price_attribute_name);
  }
  getWarehouseFulfillmentPrice() {
    return this.getAttribute(Order.order_fulfillment_price_attribute_name);
  }
  getUpsellPrice() {
    return this.getAttribute(Order.order_upsell_price_attribute_name);
  }
  static isValidOrderStatus(status) {
    return Order.getAllOrderStatuses().includes(status);
  }
  status() {
    return this.getAttribute(Order.order_status_attribute_name);
  }
  isDelivered() {
    return this.status() === Order.DELIVERED_STATUS;
  }
  isShipped() {
    return this.status() === Order.SHIPPED_STATUS;
  }
  static getAllOrderStatuses() {
    return [Order.PENDING_STATUS, Order.CONFIRMED_STATUS, Order.SHIPPED_STATUS, Order.DELIVERED_STATUS, Order.CANCELED_STATUS, Order.RETURNED_STATUS, Order.PROCESSING_STATUS, Order.NO_ANSWER_STATUS];
  }
  getOrderStatus() {
    return this.getAttribute(Order.order_status_attribute_name);
  }
  getStatus() {
    return this.getAttribute(Order.order_status_attribute_name);
  }
  getOrderOrdersLines() {
    var _this$getAttribute3;
    return (_this$getAttribute3 = this.getAttribute(Order.order_lines_attribute_name)) !== null && _this$getAttribute3 !== void 0 ? _this$getAttribute3 : [];
  }
  getOrderTotalAmount() {
    return this.getOrderOrdersLines().reduce((s, order_lines) => {
      if (order_lines instanceof OrderLine) return s + order_lines.getOrderLineUsdConfirmedTotal();
      return s + null;
    }, 0);
  }
  getOrderSalePage() {
    return this.getAttribute(Order.order_sale_page_attribute_name);
  }
  getSalePage(trashed = false) {
    if (trashed) {
      var _ref3, _this$getAttribute4;
      return (_ref3 = (_this$getAttribute4 = this.getAttribute(Order.order_with_trashed_sale_page_attribute_name)) !== null && _this$getAttribute4 !== void 0 ? _this$getAttribute4 : this.getAttribute(Order.with_trashed_sale_page_attribute_name)) !== null && _ref3 !== void 0 ? _ref3 : this.getAttribute(Order.order_sale_page_attribute_name);
    }
    return this.getAttribute(Order.order_sale_page_attribute_name);
  }
  getPageUrl(trashed = true) {
    let page = this.getSalePage(trashed);
    return page instanceof SalePage ? page.getSalePageLink() : null;
  }
  getOrderOfferPayout() {
    let offer = this.getOffer(true);
    return offer instanceof Offer ? offer.getPayout() : null;
  }
  getOrderLines() {
    let orderLines = this.getAttribute(Order.order_lines_attribute_name);
    return Array.isArray(orderLines) ? orderLines : [];
  }
  getOfferCountry(trashed = false) {
    let offer = this.getOffer(trashed);
    return offer instanceof Offer ? offer.getCountry() : null;
  }
  getOffer(trashed = false) {
    let salePage = this.getSalePage(trashed);
    return salePage instanceof SalePage ? salePage.getOffer(trashed) : null;
  }
  getOfferRequiredCommissionStatus() {
    let offer = this.getOffer(true);
    return offer instanceof Offer ? offer.statusRequiredForCommission() : Order.DELIVERED_STATUS;
  }
  isDeliveredOfferRequiredCommissionStatus() {
    return this.getOfferRequiredCommissionStatus() === Order.DELIVERED_STATUS;
  }
  isConfirmedOfferRequiredCommissionStatus() {
    return this.getOfferRequiredCommissionStatus() === Order.CONFIRMED_STATUS;
  }
  getPayment() {
    return this.getAttribute(Order.order_payment_attribute_name);
  }
  getPaymentMethod() {
    let payment = this.getPayment();
    return payment instanceof Payment ? payment.getPaymentMethod() : null;
  }
  getPaymentType() {
    return this.getAttribute(Order.order_payment_type_attribute_name);
  }
  isCardPaymentOrder() {
    return this.getPaymentType() === Offer.CARD_PAYMENT_TYPE;
  }
  isCodPaymentOrder() {
    return this.getPaymentType() === Offer.COD_PAYMENT_TYPE;
  }
  getClient() {
    var _this$getAttribute5;
    return (_this$getAttribute5 = this.getAttribute(Order.order_client_attribute_name)) !== null && _this$getAttribute5 !== void 0 ? _this$getAttribute5 : this.getAttribute(Order.client_attribute_name);
  }
  getClientCountry() {
    let client = this.getClient();
    return client instanceof Client ? client.getCountry() : null;
  }
  getSdkAccountOrders() {
    return this.getAttribute(Order.getSdkAccountOrdersAttributeName());
  }
  getWarehouseSdkOrder() {
    const sdkAccountOrders = this.getSdkAccountOrders();
    return Array.isArray(sdkAccountOrders) && sdkAccountOrders.find(sdkAccountOrder => {
      if (!(sdkAccountOrder instanceof SdkAccountOrder)) {
        return false;
      }
      const sdkAccount = sdkAccountOrder.getSdkAccount();
      if (!(sdkAccount instanceof ECommerceSdkAccount)) {
        return false;
      }
      const accountOwner = sdkAccount.getAccountOwner();
      if (!(accountOwner instanceof User)) {
        return false;
      }
      return accountOwner.isWarehouse();
    });
  }
  isSentToWarehouse() {
    const sdkAccountOrders = this.getSdkAccountOrders();
    return Array.isArray(sdkAccountOrders) && sdkAccountOrders.some(sdkAccountOrder => {
      if (!(sdkAccountOrder instanceof SdkAccountOrder)) {
        return false;
      }
      const sdkAccount = sdkAccountOrder.getSdkAccount();
      if (!(sdkAccount instanceof ECommerceSdkAccount)) {
        return false;
      }
      const accountOwner = sdkAccount.getAccountOwner();
      if (!(accountOwner instanceof User)) {
        return false;
      }
      return accountOwner.isWarehouse() && sdkAccountOrder.isSuccessful();
    });
  }
  getTrackingLink() {
    return this.getAttribute(Order.order_tracking_link_attribute_name);
  }
  isSentToAdvertiser() {
    return this.getAttribute(Order.is_sent_to_advertiser_attribute_name);
  }
  hasStoredUpsell() {
    return this.getOrderLines().some(orderLine => orderLine instanceof OrderLine && orderLine.isUpSell() && orderLine.hasQuantityConfirmed());
  }
  hasCalledUpsell() {
    return this.getOrderLines().some(orderLine => orderLine instanceof OrderLine && orderLine.isUpSell() && orderLine.hasQuantityConfirmed() > orderLine.getQuantity());
  }
  getCountry() {
    let client = this.getClient();
    return client instanceof Client ? client.getCountry() : null;
  }
  getProduct(trashed = false) {
    let salePage = this.getSalePage(trashed);
    return salePage.getProduct(trashed);
  }
  getProductName(trashed = false) {
    let product = this.getProduct(trashed);
    return product instanceof Product ? product.getName() : null;
  }
  getOrderComments() {
    var _this$getAttribute6;
    return (_this$getAttribute6 = this.getAttribute(Order.order_call_agent_order_comments_attribute_name)) !== null && _this$getAttribute6 !== void 0 ? _this$getAttribute6 : [];
  }
  canInvoice() {
    return this.isCardPaymentOrder() ? this.isDelivered() || this.isShipped() : this.isCodPaymentOrder() ? this.isDeliveredOfferRequiredCommissionStatus() ? this.isDelivered() : this.isConfirmedOfferRequiredCommissionStatus() ? [Order.CONFIRMED_STATUS, Order.SHIPPED_STATUS, Order.DELIVERED_STATUS].includes(this.getOrderStatus()) : false : false;
  }
  getMainOrderLine() {
    let orderLines = this.getOrderLines();
    return orderLines.find(ol => ol instanceof OrderLine ? ol.isMain() : false);
  }
  getUpsells() {
    let orderLines = this.getOrderLines();
    return orderLines.filter(ol => ol instanceof OrderLine ? ol.isUpsell() : false);
  }
  getCrossSells() {
    let orderLines = this.getOrderLines();
    return orderLines.filter(ol => ol instanceof OrderLine ? ol.isCrossSell() : false);
  }
  getUpsellsConfirmedQuantity() {
    let upsells = this.getUpsells();
    return upsells.reduce((init, upsell) => init + (upsell instanceof OrderLine ? upsell.getQuantityConfirmed() : 0), 0);
  }
  getUpsellsConfirmedTotal() {
    let upsells = this.getUpsells();
    return upsells.reduce((init, upsell) => init + (upsell instanceof OrderLine ? upsell.getTotalConfirmed() : 0), 0);
  }
  getCallUpsellQuantity() {
    let upsells = this.getUpsells();
    return upsells.reduce((init, upsell) => init + (upsell instanceof OrderLine ? upsell.getCallUpsellQuantity() : 0), 0);
  }
  getCallUpsellTotal() {
    let upsells = this.getUpsells();
    return upsells.reduce((init, upsell) => init + (upsell instanceof OrderLine ? upsell.getCallUpsellTotal() : 0), 0);
  }
  getTotalConfirmed() {
    let orderLines = this.getOrderLines();
    return orderLines.reduce((init, orderLine) => init + (orderLine instanceof OrderLine ? orderLine.getTotalConfirmed() : 0), 0);
  }
  getPayout() {
    let offer = this.getOffer(true);
    return offer instanceof Offer ? offer.getPayout() : null;
  }
  getOfferName() {
    let offer = this.getOffer(true);
    return offer instanceof Offer ? offer.getName() : null;
  }
  getPayoutWithCurrency() {
    let offer = this.getOffer(true);
    let payout = offer instanceof Offer ? offer.getPayout() : null;
    return payout ? ['$', payout].join(' ') : '-';
  }
  getInvoices() {
    return this.getAttribute(Order.order_invoices_attribute_name);
  }
  isWarehousePaid() {
    return this.getAttribute(Order.is_warehouse_paid_attribute_name);
  }
  getCalculatedOrderTotal() {
    return this.getOrderLines().reduce((init, next) => {
      return init + (next instanceof OrderLine && next.hasQuantity() ? next.getTotal() : 0);
    }, 0).toFixed(2);
  }
  getCalculatedOrderTotalWithCurrency() {
    let salePage = this.getSalePage(true);
    let currencySymbol = salePage instanceof SalePage ? salePage.getCurrencySymbol() : null;
    return [currencySymbol, this.getOrderLines().reduce((init, next) => {
      return init + (next instanceof OrderLine && next.hasQuantity() ? next.getTotal() : 0);
    }, 0).toFixed(2)].join(' ');
  }
  getCalculatedOrderTotalConfirmedWithCurrency() {
    let salePage = this.getSalePage(true);
    let currencySymbol = salePage instanceof SalePage ? salePage.getCurrencySymbol() : null;
    return [currencySymbol, this.getOrderLines().reduce((init, next) => {
      return init + (next instanceof OrderLine && next.hasQuantity() ? next.getTotalConfirmed() : 0);
    }, 0).toFixed(2)].join(' ');
  }
  getCalculatedOrderTotalConfirmed() {
    return this.getOrderLines().reduce((init, next) => {
      return init + (next instanceof OrderLine && next.hasQuantity() ? next.getTotalConfirmed() : 0);
    }, 0);
  }
  getCalculatedOrderUsdTotalConfirmed() {
    return this.getOrderLines().reduce((init, next) => {
      return init + (next instanceof OrderLine && next.hasQuantity() ? next.getUsdTotalConfirmed() : 0);
    }, 0);
  }
  getCalculatedOrderUsdTotal() {
    return this.getOrderLines().reduce((init, next) => {
      return init + (next instanceof OrderLine && next.hasQuantity() ? next.getUsdTotal() : 0);
    }, 0);
  }
  getCalculatedOrderUsdTotalWithCurrency() {
    return ['$', this.getOrderLines().reduce((init, next) => {
      return init + (next instanceof OrderLine && next.hasQuantity() ? next.getUsdTotal() : 0);
    }, 0).toFixed(2)].join(' ');
  }
  getCalculatedOrderUsdTotalConfirmedWithCurrency() {
    return ['$', this.getOrderLines().reduce((init, next) => {
      return init + (next instanceof OrderLine && next.hasQuantity() ? next.getUsdTotalConfirmed() : 0);
    }, 0).toFixed(2)].join(' ');
  }
  isAffiliatePaid() {
    return this.getAttribute(Order.is_affiliate_paid_attribute_name);
  }
}
_defineProperty(Order, "PENDING_STATUS", 'pending');
_defineProperty(Order, "NO_ANSWER_STATUS", 'no_answer');
_defineProperty(Order, "CONFIRMED_STATUS", 'confirmed');
_defineProperty(Order, "SHIPPED_STATUS", 'shipped');
_defineProperty(Order, "CANCELED_STATUS", 'canceled');
_defineProperty(Order, "DELIVERED_STATUS", 'delivered');
_defineProperty(Order, "PROCESSING_STATUS", 'processing');
_defineProperty(Order, "RETURNED_STATUS", 'returned');
_defineProperty(Order, "WAREHOUSE_PAID_STATUS", 'w-paid');
_defineProperty(Order, "SELLER_PAID_STATUS", 's-paid');
_defineProperty(Order, "WAREHOUSE_NOT_PAID_STATUS", 'w-nop');
_defineProperty(Order, "SELLER_NOT_PAID_STATUS", 's-nop');
_defineProperty(Order, "NEW_CALL_STATUS", 'new');
_defineProperty(Order, "CALL_STATUS", 'call');
_defineProperty(Order, "FIRST_CALL_STATUS", 'call-1');
_defineProperty(Order, "SECOND_CALL_STATUS", 'call-2');
_defineProperty(Order, "THIRD_CALL_STATUS", 'call-3');
_defineProperty(Order, "FOURTH_CALL_STATUS", 'call-4');
_defineProperty(Order, "WRONG_NUMBER_STATUS", 'wrong-number');
_defineProperty(Order, "NO_REPLY_STATUS", 'no-reply');
_defineProperty(Order, "EXPIRED_STATUS", 'expired');
_defineProperty(Order, "SCHEDULED_STATUS", 'scheduled');
_defineProperty(Order, "WRONG_COUNTRY_STATUS", 'wrong-country');
_defineProperty(Order, "id_attribute_name", 'order_id');
_defineProperty(Order, "order_id_alias_attribute_name", 'order_id_alias');
_defineProperty(Order, "order_client_attribute_name", 'order_client');
_defineProperty(Order, "client_attribute_name", 'client');
_defineProperty(Order, "order_call_agent_attribute_name", 'order_call_agent');
_defineProperty(Order, "order_invoices_attribute_name", 'order_invoices');
_defineProperty(Order, "order_sale_page_attribute_name", 'order_sale_page');
_defineProperty(Order, "order_with_trashed_sale_page_attribute_name", 'order_with_trashed_sale_page');
_defineProperty(Order, "with_trashed_sale_page_attribute_name", 'with_trashed_sale_page');
_defineProperty(Order, "order_status_attribute_name", 'order_status');
_defineProperty(Order, "order_lines_attribute_name", 'order_lines');
_defineProperty(Order, "order_tracking_code_attribute_name", 'order_tracking_code');
_defineProperty(Order, "order_tracking_link_attribute_name", 'order_tracking_link');
_defineProperty(Order, "created_at_attribute_name", 'created_at');
_defineProperty(Order, "order_call_agent_order_comments_attribute_name", 'order_call_agent_order_comments');
_defineProperty(Order, "order_fulfillment_price_attribute_name", 'order_fulfillment_price');
_defineProperty(Order, "order_upsell_price_attribute_name", 'order_upsell_price');
_defineProperty(Order, "order_shipping_price_attribute_name", 'order_shipping_price');
_defineProperty(Order, "order_returns_price_attribute_name", 'order_returns_price');
_defineProperty(Order, "order_tax_percentage_attribute_name", 'order_tax_percentage');
_defineProperty(Order, "order_other_percentage_attribute_name", 'order_other_percentage');
_defineProperty(Order, "order_call_agent_shipping_note_attribute_name", 'order_call_agent_shipping_note');
_defineProperty(Order, "order_lines_sum_order_line_total_confirmed_usd_attribute_name", 'order_lines_sum_order_line_total_confirmed_usd');
_defineProperty(Order, "order_remittance_invoice_attribute_name", 'order_remittance_invoice');
_defineProperty(Order, "total_confirmed_usd_sum_attribute_name", 'total_confirmed_usd_sum');
_defineProperty(Order, "is_sent_to_warehouse_api_attribute_name", 'is_sent_to_warehouse_api');
_defineProperty(Order, "is_sent_to_warehouse_attribute_name", 'is_sent_to_warehouse');
_defineProperty(Order, "is_sent_to_advertiser_attribute_name", 'is_sent_to_advertiser');
_defineProperty(Order, "order_payment_type_attribute_name", 'order_payment_type');
_defineProperty(Order, "order_payment_attribute_name", 'order_payment');
_defineProperty(Order, "order_total_confirmed_usd_attribute_name", 'order_total_confirmed_usd');
_defineProperty(Order, "order_total_confirmed_attribute_name", 'order_total_confirmed');
_defineProperty(Order, "payment_status_attribute_name", 'payment_status');
_defineProperty(Order, "is_affiliate_paid_attribute_name", 'is_affiliate_paid');
_defineProperty(Order, "is_warehouse_paid_attribute_name", 'is_warehouse_paid');
_defineProperty(Order, "google_sheet_sends_attribute_name", 'google_sheet_sends');
_defineProperty(Order, "sdk_account_orders_attribute_name", 'sdk_account_orders');
_defineProperty(Order, "has_google_sheet_attribute_name", 'has_google_sheet');
_defineProperty(Order, "sent_to_all_google_sheets_attribute_name", 'sent_to_all_google_sheets');